import React from "react";
import cookie from "react-cookies";
import InputMask from "react-input-mask";
import validator from "validator";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { push } from "react-router-redux";
import { Form, Grid, Header, Select } from "semantic-ui-react";
import API from "../../API/API";
import ModalSendEmail from "../../components/ModalSendEmail";
import { GetContent, GetRichTextFromContent } from "../../scripts";

import FormValidator from "../../utils/formValidator";

const getQueryVariable = variable => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) === variable) {
      let finalValue = decodeURIComponent(pair[1]);
      return decodeURIComponent(finalValue);
    }
  }
  return "";
};

const genderSelector = [
  { id: 1, text: "Masculino", value: "M" },
  { id: 2, text: "Femenino", value: "F" }
];

class ContactoScreen extends React.Component {

  rules = [
    {
      field: "email",
      method: validator.isEmpty,
      validWhen: false,
      message: "El correo es requerido."
    },
    {
      field: "email",
      method: validator.isEmail,
      validWhen: true,
      message: "Ingresa un email valido."
    }
  ];
  validator = {};
  validation = {};

  constructor(props) {
    super(props);

    this.catalog = "";
    this.fromCheck = "";
    this.developmentCheck = "";
    this.stateCheck = "";
    this.promoCheck = "";

    this.sectionContent = {};
    this.dickref = React.createRef();
    this.contactContent = {};
    this.verifyPages = this.verifyPages.bind(this);
    let currentMexicoStates = [];

    this.state = {
      name: "",
      lastname1: "",
      lastname2: "",
      email: "",
      isValidEmail: false,
      birthday: "",
      stateBirth: "",
      states: currentMexicoStates,
      stateName: "",
      gender: "",
      tel: "",
      mobile: "",
      showModal: false,
      error: false
    };

    
    this.modal = {};
    this.contact = {};
    this.verifyPages = this.verifyPages.bind(this);
    this.validator = new FormValidator(this.rules);
    this.contactInfo = {};

    this.states = this.props.states;
  }

  verifyPages(pages) {
    if (pages.length > 0) {
      const api = new API();
      const pageId = pages[0].id;

      api.getContentOf(pageId).then(response => {
        this.sectionContent = GetContent(response[0], "contact", "info");
        this.forceUpdate();
      });
      this.forceUpdate();
    }
    this.forceUpdate();
  }

  checkDataURL() {
    if (
      this.props &&
      this.props.location &&
      (this.props.location.state !== null &&
        this.props.location.state !== undefined)
    ) {
      this.catalog = this.props.location.state.catalog;
      this.fromCheck = this.props.location.state.from;
      this.developmentCheck = this.props.location.state.development;
      this.stateCheck = this.props.location.state.state;
      this.promoCheck = this.props.location.state.promo;
    } else {
      this.catalog = getQueryVariable("catalog");
      this.fromCheck = getQueryVariable("from");
      this.developmentCheck = getQueryVariable("development");
      this.stateCheck = getQueryVariable("state");
      this.promoCheck = getQueryVariable("promo");
    }

    this.checkDevelopment(this.stateCheck);
    this.setState({
      interesState: this.stateCheck,
      interesDevelopment: this.developmentCheck
    });
  }

  componentWillMount() {
    const gaCookie = cookie.load("_ga");
    this.setState({ gaCookie: gaCookie });
  }

  componentDidMount() {
    const api = new API();
    api
      .getInformacionLugaresNacimiento()
      .then(response => {
        let estados = [];
        for (let i = 0; i < response.length; i++) {
          const addState = {
            key: response[i].clave_curp_estado,
            value: response[i].clave_curp_estado,
            text: response[i].desc_entidad_federativa
          };
          estados.push(addState);
        }
        estados.sort((a, b) =>
          a.text > b.text ? 1 : b.text > a.text ? -1 : 0
        );
        this.setState({ states: estados });
      })
      .catch(error => {});
    this.verifyPages(this.props.pages);
  }

  componentWillReceiveProps(nextProps) {
    this.verifyPages(nextProps.pages);
  }

  componentWillUpdate(){
    this.validationExist = Object.keys(this.validation).length
        ? true
        : false;
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  checkState() {
    let currentStates = [];
    for (let i = 0; i < this.states.length; i++) {
      const currentState = this.states[i];
      const newState = {};
      newState.key = currentState.id;
      newState.value = currentState.id;
      newState.text = currentState.name;
      currentStates.push(newState);
    }
    this.setState({ developmentStates: currentStates });
  }

  handleSubmit = () => {
    const {
      name,
      lastname1,
      lastname2,
      email,
      birthday,
      stateBirth,
      gender,
      tel,
      mobile,
      stateName
    } = this.state;
    this.setState({ didTrySend: false });
    this.validation = this.validator.validate(this.state);

    if (
      name === "" ||
      name.trim().length === 0 ||
      lastname1 === "" ||
      lastname1.trim().length === 0 ||
      lastname2 === "" ||
      lastname2.trim().length === 0 ||
      (this.validationExist && this.validation.email.isInvalid) ||
      (tel !== "" && tel.replace(/[^0-9]/g, "").toString().length < 10) ||
      mobile.replace(/[^0-9]/g, "").toString().length < 10 ||
      gender === ""
    ) {
      this.setState({ didTrySend: true, error: true });
      return;
    }

    const modelId = (this.props.location.state && this.props.location.state.modelId)? this.props.location.state.modelId : '';
    let tempCallHour = -1;
    let message = "";
    let openValue = "";
    let descCamp = "Orgánico";
    let descCampId = "-";
    if (this.props.idcheck.key !== undefined) {
      descCampId = this.props.idcheck.value;
      descCamp = this.props.idcheck.key;
    }
    let originId = "1";
    if (this.fromCheck !== "") {
      originId = this.fromCheck;
    }

    if (this.promoCheck !== "") {
      openValue = "Promocion de Interes: " + this.promoCheck;
    }

    let idFrac = parseInt(this.props.propData.idFraccionamiento);
    const dataSend = {
      idFraccionamiento: idFrac,
      nombre: name,
      apellidoPaterno: lastname1,
      apellidoMaterno: lastname2,
      telefonoCasa: tel.replace(/[^0-9]/g, ""),
      cveLadaCasa: "",
      telefonoCelular: mobile.replace(/[^0-9]/g, ""),
      cveLadaCelular: "",
      rfc: "CUMG950118C84",
      numeroSeguroSocial: "",
      curp: "CUMG950118MCSRTD10",
      email: email,
      sexo: gender,
      fechaCita: "",
      mensaje: message,
      idCategoriaWeb: "1826",
      idOrigenWeb: originId,
      idEdoNavWeb: "1",
      creditoContacto: "0",
      campoAbierto: openValue,
      origen: "DREAMLAGOONS",
      idCampania: descCampId,
      descCampania: descCamp,
      codigo: this.state.gaCookie,
      horario: tempCallHour
    };
    const api = new API();
    api.contactARA(dataSend).then(response => {
      console.log(response);
    });

    let phoneAdd = "";
    if (mobile !== "") {
      phoneAdd = mobile;
    } else {
      phoneAdd = tel;
    }
    let nameSend = name + " " + lastname1 + " " + lastname2;
    api.sendEmailWelcome(nameSend, email, phoneAdd, modelId).then(response => {});

    this.setState({
      submittedEmail: email,
      showModal: true,
      modalName: nameSend,
      modalEmail: email,
      modalTel: phoneAdd
    });
    let currentCatalog = undefined;
    if (this.props.location.state !== undefined) {
      currentCatalog = this.props.location.state.catalog;
      if (currentCatalog !== undefined) {
        window.open(currentCatalog, "_blank");
      }
    }
  };

  renderInDesktop() {
    let currentCatalog = undefined;
    if (this.props.location.state !== undefined) {
      currentCatalog = this.props.location.state.catalog;
    }
    return (
      <div
        style={{
          background: "#edf1f3",
          textAlign: "center",
          zIndex: 999,
          marginTop: "-5px"
        }}
        id="contact"
        className="fixSpaceContact"
      >
        <Header
          style={{
            color: "#5aa7d1"
          }}
          className="title"
        >
          Contacto
        </Header>
        <div
          style={{ marginBottom: "2rem" }}
          dangerouslySetInnerHTML={{
            __html: GetRichTextFromContent(
              this.sectionContent,
              "info",
              this.props.currentlanguage
            )
          }}
        />
        <Form>
          <Grid stackable>
            <Grid.Row columns={4} centered>
              <Grid.Column>
                <Form.Input
                  fluid
                  placeholder="Nombre"
                  error={
                    (this.state.name === "" ||
                      this.state.name.trim().length === 0) &&
                    this.state.didTrySend === true
                  }
                  required
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange}
                  style={{
                    border: 0,
                    borderRadius: 0
                  }}
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  fluid
                  placeholder="Apellido (Paterno)"
                  error={
                    (this.state.lastname1 === "" ||
                      this.state.lastname1.trim().length === 0) &&
                    this.state.didTrySend === true
                  }
                  required
                  name="lastname1"
                  value={this.state.lastname1}
                  onChange={this.handleChange}
                  style={{
                    border: 0,
                    borderRadius: 0
                  }}
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  fluid
                  placeholder="Apellido (Materno)"
                  required
                  error={
                    (this.state.lastname2 === "" ||
                      this.state.lastname2.trim().length === 0) &&
                    this.state.didTrySend === true
                  }
                  name="lastname2"
                  value={this.state.lastname2}
                  onChange={this.handleChange}
                  style={{
                    border: 0,
                    borderRadius: 0
                  }}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4} centered>
              <Grid.Column>
                <Form.Input
                  fluid
                  placeholder="Correo electrónico"
                  error={
                    ((this.validationExist && this.validation.email.isInvalid) &&
                    this.state.didTrySend)
                  }
                  required
                  name="email"
                  value={this.state.email}
                  onChange={event => {
                    this.validation = this.validator.validate({email: event.target.value});
                    this.setState({
                      isValidEmail: this.validation.email.isInvalid
                    });
                    this.handleChange(event, {
                      name: "email",
                      value: event.target.value
                    });
                  }}
                  style={{
                    border: 0,
                    borderRadius: 0
                  }}
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  fluid
                  placeholder="Teléfono Móvil"
                  required
                  error={
                    this.state.mobile.replace(/[^0-9]/g, "").toString().length <
                      10 && this.state.didTrySend === true
                  }
                  name="mobile"
                  value={this.state.mobile}
                  style={{
                    border: 0,
                    borderRadius: 0
                  }}
                  children={
                    <InputMask
                      placeholder="Teléfono Móvil (55) 5555-5555"
                      mask="(99) 9999-9999"
                      name="mobile"
                      value={this.state.mobile}
                      onChange={event => {
                        this.handleChange(event, {
                          name: "mobile",
                          value: event.target.value
                        });
                      }}
                    />
                  }
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  fluid
                  placeholder="Teléfono Fijo"
                  error={
                    this.state.tel !== "" &&
                    this.state.tel.replace(/[^0-9]/g, "").toString().length <
                      10 &&
                    this.state.didTrySend === true
                  }
                  required
                  name="tel"
                  value={this.state.tel}
                  style={{
                    border: 0,
                    borderRadius: 0
                  }}
                  children={
                    <InputMask
                      placeholder="Teléfono Fijo (55) 5555-5555"
                      mask="(99) 9999-9999"
                      name="tel"
                      value={this.state.tel}
                      onChange={event => {
                        this.handleChange(event, {
                          name: "tel",
                          value: event.target.value
                        });
                      }}
                    />
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4} centered>
              <Grid.Column>
                <Form.Field>
                  <Select
                    fluid
                    name="gender"
                    error={
                      this.state.gender === "" && this.state.didTrySend === true
                    }
                    value={this.state.gender}
                    options={genderSelector}
                    onChange={this.handleChange}
                    placeholder="Género"
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className={"marginTopByH"} />
          <div style={{ width: "100%" }}>
            <button
              onClick={this.handleSubmit}
              style={{
                width: "260px",
                height: "50px",
                borderRadius: "30px",
                background: "#5aa7d1",
                color: "white",
                cursor: "pointer"
              }}
            >
              {currentCatalog === undefined
                ? "SOLICITAR LLAMADA"
                : "DESCARGAR CATALOGO"}
            </button>
            <div style={{ height: "0.7rem" }} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "0rem 0rem",
                visibility: this.state.error ? "visible" : "hidden"
              }}
            >
              <t style={{ color: "red" }}>
                Por favor ingresa los campos marcados en rojo.
              </t>
            </div>
          </div>
          <div className={"fixMarginBottomByH"} />
        </Form>
        <ModalSendEmail
          showModal={this.state.showModal}
          closeModal={() => {
            this.setState({
              name: "",
              lastname1: "",
              lastname2: "",
              email: "",
              isValidEmail: false,
              birthday: "",
              stateBirth: "",
              stateName: "",
              gender: "",
              tel: "",
              mobile: "",
              showModal: false,
              error: false
            });
            this.props.push({
              pathname: window.location.pathname
            });
          }}
          name={this.state.modalName}
          email={this.state.modalEmail}
          tel={this.state.modalTel}
        />
      </div>
    );
  }

  render() {
    return <div>{this.renderInDesktop()}</div>;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

const mapStateToProps = ({ state, data }) => {
  const { pages, idcheck } = data;
  return {
    state,
    pages,
    idcheck
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContactoScreen)
);
